import i18n from "@/lib/i18n";
import Tabs from "@/components/UsersGroupsTabs.vue";

export const config = {
  name: "institutionsWorkersGroups",
  route: "/institutionsWorkersGroups",
  store: "institutionsWorkersGroups",

  model: [{ id: "name", label: i18n.t("Group name"), searchable: true }],

  pages: {
    icon: "fa-user-friends",

    list: {
      actions: [
        {
          title: i18n.t("pages.institutionsWorkersGroups.add"),
          route: "institutionsWorkersGroups.create",
        },
      ],

      quickFilters: Tabs,
    },
  },
};
